import { SEARCH_RESET } from './search.constants';

export const resetSearch = () => ({ type: SEARCH_RESET });
